import { setItem, getItem, clearAll, removeItem } from './browserStorage'

const getLocalStorage = () => {
  const { localStorage } = window || global

  return localStorage
}

export const add = (key: string, value: string): void => setItem(getLocalStorage(), key, value)

export const get = (key: string, defaultValue: string): string => getItem(getLocalStorage(), key, defaultValue)

export const remove = (key: string): void => removeItem(getLocalStorage(), key)

export const clear = (): void => clearAll(getLocalStorage())

export const Keys = {
  LOCALE: 'locale',
}
